import { render, staticRenderFns } from "./WisdomStatsDataTable.vue?vue&type=template&id=403c67d4&"
import script from "./WisdomStatsDataTable.vue?vue&type=script&lang=js&"
export * from "./WisdomStatsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./WisdomStatsDataTable.vue?vue&type=style&index=0&id=403c67d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports